"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scheme = void 0;
const env_1 = __importDefault(require("./env"));
exports.Scheme = {
    get: (target, prop) => {
        if (prop.startsWith('_'))
            throw new Error('Access denied');
        if (env_1.default.isMobile)
            throw new Error('Crossmark only available from desktop');
        let value = target[prop];
        return typeof value === 'function' ? value.bind(target) : value;
    },
    set: (target, prop, val) => {
        if (prop.startsWith('_')) {
            throw new Error('Access denied');
        }
        else {
            target[prop] = val;
            return true;
        }
    },
    deleteProperty: (target, prop) => {
        if (prop.startsWith('_')) {
            throw new Error('Access denied');
        }
        else {
            delete target[prop];
            return true;
        }
    },
    ownKeys: (target) => {
        return Object.keys(target).filter((key) => !key.startsWith('_'));
    },
};
